import * as React from 'react';
import { styled } from '@glitz/react';
import { Heading } from './general-styling';
import { CheckboxAlign, CheckboxField } from 'webapp/components/form/checkbox-field';
import { NnTestIdProps } from 'webapp/shared/test-ids';

type PropType = {
  facet: Excite.Esales.FacetApiModel;
  onFacetValueChange: (
    updatedFacet: Excite.Esales.FacetApiModel,
    changedValue: Excite.Esales.FacetValueApiModel,
  ) => void;
};

export function toFacetValue(checked: boolean) {
  return checked
    ? ({ selected: true, text: 'true' } as Excite.Esales.FacetValueApiModel)
    : ({ selected: false, text: 'false' } as Excite.Esales.FacetValueApiModel);
}

export const BooleanFacet = React.memo(({ facet, onFacetValueChange }: PropType) => {
  const checked = facet.values.filter(t => t.selected).length > 0;

  return (
    <Base {...NnTestIdProps.BooleanFacet}>
      <FacetValue
        onChange={e =>
          onFacetValueChange(
            {
              ...facet,
              values: [toFacetValue(e.currentTarget.checked)],
            },
            toFacetValue(e.currentTarget.checked),
          )
        }
        checkboxAlign={CheckboxAlign.Right}
        checked={checked}
      >
        <Heading>{facet.text}</Heading>
      </FacetValue>
    </Base>
  );
});

const Base = styled.li({
  padding: { x: t => t.sharedSpacing.l, y: t => t.sharedSpacing.m },
  borderBottom: { style: 'solid', width: 'thin', color: t => t.facets?.borderColor },
});
const FacetValue = styled(CheckboxField, {
  fontSize: t => t.facets?.count?.fontSize,
  width: '100%',
});
